import {TooltipProps, Zoom} from '@mui/material';

import {Tooltip} from '~components/common/Tooltip';

export function ToolbarTooltip({placement = 'top-start', ...props}: TooltipProps) {
  return (
    <Tooltip placement={placement} arrow TransitionComponent={Zoom} disableInteractive {...props}>
      {props.children}
    </Tooltip>
  );
}
